<template>
  <a-form-model
    ref="editInstitutionForm"
    :form="form"
    :model="form"
    @submit="handleSubmit"
    @submit.native.prevent
  >
    <div class="w-full flex">
      <a-form-model-item label="Name" prop="name" class="mr-4 flex-1">
        <a-input v-model="form.name" class="w-full" />
      </a-form-model-item>
    </div>
    <div class="w-full flex">
      <a-form-model-item
        label="Reporting currency"
        prop="currency"
        class="mr-4 flex-1"
      >
        <a-select v-model="form.currency" showSearch>
          <a-select-option
            v-for="currency in currencies"
            :key="currency"
            :value="currency"
          >
            {{ currency }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
    </div>
    <div class="w-full flex">
      <a-form-model-item label="ISIN" prop="isin" class="mr-4 flex-1">
        <a-input v-model="form.isin" class="w-full" />
      </a-form-model-item>
    </div>
    <a-button
      type="primary"
      html-type="submit"
      :disabled="isSaving || !form.name || !form.currency"
    >
      Save
    </a-button>
    <a-button class="ml-4" @click="onCancelButtonClicked()">
      Cancel
    </a-button>
  </a-form-model>
</template>

<script>
import gql from 'graphql-tag'
import currencies from '../../data/Currencies'

export default {
  props: {
    institution: {
      type: Object,
    },
  },
  data() {
    return {
      form: {
        name: this.institution ? this.institution.name : '',
        isin: this.institution ? this.institution.isin : '',
        currency: this.institution ? this.institution.currency : '',
      },
      isSaving: false,
      currencies,
    }
  },
  methods: {
    async handleSubmit() {
      if (this.form.name && this.form.currency) {
        try {
          this.isSaving = true
          if (this.institution) {
            await this.updateInstitution()
          } else {
            await this.addInstitution()
          }
          this.isSaving = false
          this.$refs.editInstitutionForm.resetFields()
          this.$emit('institution-saved')
        } catch (error) {
          this.$message.error(error.message)
          this.isSaving = false
        }
      } else {
        return false
      }
    },
    async addInstitution() {
      await this.$apollo.mutate({
        mutation: gql`
          mutation($input: AddFinancialInstitutionInput) {
            addFinancialInstitution(input: $input) {
              id
            }
          }
        `,
        variables: {
          input: {
            name: this.form.name,
            isin: this.form.isin,
            currency: this.form.currency,
          },
        },
      })
    },
    async updateInstitution() {
      await this.$apollo.mutate({
        mutation: gql`
          mutation($input: UpdateFinancialInstitutionInput) {
            updateFinancialInstitution(input: $input) {
              id
            }
          }
        `,
        variables: {
          input: {
            id: this.institution.id,
            name: this.form.name,
            isin: this.form.isin,
            currency: this.form.currency,
          },
        },
      })
    },
    onCancelButtonClicked() {
      this.$emit('cancel-button-clicked')
      this.$refs.editInstitutionForm.resetFields()
    },
  },
  watch: {
    institution(newVal) {
      this.form.name = newVal ? newVal.name : ''
      this.form.isin = newVal ? newVal.isin : ''
      this.form.currency = newVal ? newVal.currency : ''
    },
  },
}
</script>

<style></style>
